import { connect } from 'react-redux';
import Component from './Component';

import selectOrderTotals from './Selectors/selectOrderTotals';

import onClickEdit from './Handlers/onClickEdit';
import onClickCancel from './Handlers/onClickCancel';
import onClickSave from './Handlers/onClickSave';
import onClickDeleteItems from './Handlers/onClickDeleteItems';
import onClickSubOrder from './Handlers/onClickSubOrder';

const mapStateToProps = (state) => {
  const procurementItems = (state.screens.OrderView.procurementItems || []).filter(item => !item._pendingDelete);
  
  const procurementTotals = procurementItems.reduce((acc, item) => {
    const qty = parseFloat(String(item.quantity || 0).replace(/,/g, '')) || 0;
    const unitCost = parseFloat(String(item.unit_cost || 0).replace(/,/g, '')) || 0;
    const taxRate = parseFloat(String(item.tax_rate || 0).replace(/,/g, '')) || 0;
    const excVat = qty * unitCost;
    const incVat = excVat * (1 + taxRate / 100);
    
    return {
      excVat: acc.excVat + excVat,
      incVat: acc.incVat + incVat,
    };
  }, { excVat: 0, incVat: 0 });
  
  return {
    orderTotals: selectOrderTotals(state),
    order: state.screens.OrderView.order,
    editable: state.screens.OrderView.editable,
    selectedOrderItemIds: state.screens.OrderView.selectedOrderItemIds,
    procurementTotalExcVat: procurementTotals.excVat,
    procurementTotalIncVat: procurementTotals.incVat,
  };
}

const actionCreators = {
  onClickEdit,
  onClickCancel,
  onClickSave,
  onClickDeleteItems,
  onClickSubOrder,
};

export default connect(mapStateToProps, actionCreators)(Component);